/** @format */

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FilterType, InvalidResponse } from '../../model';
import {
	addReviewFilter,
	addSelectedTag,
	removeReviewFilter,
	removeSelectedFeature,
	removeSelectedTag,
	setRatingFilter
} from '../actions';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { selectRatingFilters, selectSelectedFeature } from '../selects';

import { Injectable } from '@angular/core';
import { ProductReviewProsConsType } from '../../model/product-review-pros-cons.enum';
import { SelectedFilterType } from 'libs/product-reviews/components/src/lib/models/filter.interface';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable()
export class ProductReviewsFilterEffects {
	addSelectedTag$ = createEffect(() =>
		this.actions$.pipe(
			ofType(addSelectedTag),
			map(({ selectedTag: { id, selectedFrequency } }) => {
				const filter = {
					id,
					label: selectedFrequency.name,
					name: id,
					type: FilterType.TAG,
					value: selectedFrequency.name
				};

				return addReviewFilter({ filter });
			})
		)
	);

	removeReviewFilter$ = createEffect(() =>
		this.actions$.pipe(
			ofType(removeReviewFilter),
			map(({ filterId }) => removeSelectedTag({ tagId: filterId }))
		)
	);

	setRatingFilter$ = createEffect(() =>
		this.actions$.pipe(
			ofType(setRatingFilter),
			withLatestFrom(
				this.store.select(selectRatingFilters),
				this.store.select(selectSelectedFeature)
			),
			map(([{ rating }, selectedRatingFilters, selectedFeature]) => {
				const filterId = `${FilterType.RATING}-${rating.key}`;
				const ratingValue = Number(rating.key);
				const hasSelectedFeature =
					selectedFeature && !(selectedFeature instanceof InvalidResponse);

				if (!rating.selected) {
					const isLastSelectedRating = selectedRatingFilters.length === 1;
					if (hasSelectedFeature && isLastSelectedRating) {
						return [removeSelectedFeature(), removeReviewFilter({ filterId })];
					}
					return [removeReviewFilter({ filterId })];
				}

				const filterAction = addReviewFilter({
					filter: {
						id: filterId,
						label: rating.label,
						name: SelectedFilterType.RATING,
						type: FilterType.RATING,
						value: rating.key
					}
				});

				if (hasSelectedFeature) {
					const isPro = selectedFeature.type === ProductReviewProsConsType.PRO;
					const isCon = selectedFeature.type === ProductReviewProsConsType.CON;

					if (isPro && ratingValue <= 2) {
						return [removeSelectedFeature(), filterAction];
					}

					if (isCon && ratingValue >= 4) {
						return [removeSelectedFeature(), filterAction];
					}
				}

				return [filterAction];
			}),
			mergeMap((actions) => of(...actions))
		)
	);

	constructor(
		private readonly actions$: Actions,
		private readonly store: Store
	) {}
}
